import React from "react";
import SectionShell from "./SectionShell";
import ProjectCostCalculator from "../../utils/ProjectCostCalculator";

export default function ValueProps({ heading, bullets, image, featuredContractor }) {
  const items = Array.isArray(bullets) ? bullets : [];

  return (

    <div style={{ justifyContent:"center",display:'flex' }}>
      <SectionShell>

        <div className="cl-twoCol">
          {image?.src && (
            <div className="cl-featureImageWrapBottom">
              <img
                src={image.src}
                alt={image.alt || ""}
                className="cl-featureImageBottom"
              />
            </div>
          )}

          <div className="cl-valueLeft">
            {/* CHECKLIST COLUMN */}
            <ul className="cl-checkList">
              {heading ? <div className="cl-h2-b">{heading}</div> : null}
              {items.map((t, i) => (
                <li key={`${t}-${i}`} className="cl-checkItem">
                  <span className="cl-checkMark">✓</span>
                  <span>{t}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </SectionShell>
    </div>
  );
}
